import React from "react";
import PropTypes from "prop-types";
// Material imports
import makeStyles from "@mui/styles/makeStyles";
import Typography from "@mui/material/Typography";
//Limitless imports
import { useTranslation } from "@limitless/common/hooks";
import TimePosted from "../time-posted/TimePosted";
import TranslationText from "../translation-text/TranslationText";
const useStyles = makeStyles(({
  palette
}) => ({
  authorContainer: {
    display: "flex",
    marginTop: 16,
    marginBottom: 16,
    color: palette.secondary.contrastText
  },
  dialogueListContainer: {
    display: "flex",
    flex: "1",
    flexDirection: "row"
  },
  dialogueListItem: {
    display: "flex",
    position: "relative",
    borderRadius: 20,
    boxShadow: "0px 2px 6px -2px rgba(0, 0, 0, 0.06)",
    backgroundColor: palette.secondary.light,
    padding: 16,
    flexDirection: "column",
    width: "fit-content"
  },
  responseTime: {
    display: "flex",
    paddingTop: 8,
    justifyContent: "space-between"
  },
  dialogueContainer: {
    display: "flex",
    flexDirection: "column",
    maxWidth: "60%"
  }
}));
const ThirdPartyDialogueWrapper = ({
  children,
  dialogue,
  message
}) => {
  const classes = useStyles();
  const {
    created,
    author
  } = dialogue;
  const {
    t
  } = useTranslation();
  return /*#__PURE__*/React.createElement("div", {
    className: classes.dialogueListContainer
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.dialogueContainer
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.dialogueListItem
  }, dialogue.type === "aiSummary" && /*#__PURE__*/React.createElement(Typography, {
    variant: "body2",
    paddingBottom: 2
  }, t("Conversation Summary")), children, dialogue.type !== "aiSummary" && /*#__PURE__*/React.createElement("div", {
    className: classes.authorContainer
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "caption"
  }, author && t("{0}", author)))), /*#__PURE__*/React.createElement("div", {
    className: classes.responseTime
  }, /*#__PURE__*/React.createElement(TimePosted, {
    time: created
  }), message.conversationState.isTranslated && /*#__PURE__*/React.createElement(TranslationText, null))));
};
export default ThirdPartyDialogueWrapper;
ThirdPartyDialogueWrapper.propTypes = {
  children: PropTypes.node.isRequired,
  dialogue: PropTypes.object.isRequired,
  dialogueSuffixMap: PropTypes.object,
  message: PropTypes.object.isRequired
};